/**
 * Parses a raw string from a decimal input field into a rounded number.
 *
 * - NaN input returns `fallback` (default 0).
 * - Negative values are clamped to 0.
 * - Values are rounded to at most 2 decimal places.
 *
 * Used for currency and hours fields on blur.
 */
export const parseDecimalInput = (raw: string, fallback = 0): number => {
  const v = parseFloat(raw);
  return Number.isNaN(v) ? fallback : Math.max(0, Math.round(v * 100) / 100);
};
